import Md5 from 'md5'
export function $toggle_lang(){
    if(this.$i18n.locale == 'en'){
        this.$i18n.locale='zh'
    }else{
        this.$i18n.locale='en'
    }
}
export const md5 = Md5


export function getUUid(){  //获取uuid
    if(!sessionStorage['RFIDuuid']){
        this.Req(this.Init('getUuid'),res=>{
            if(res.ret=='1'){
                if(res.params.uuid){
                    sessionStorage['RFIDuuid'] = res.params.uuid
                }                        
            }
        })
    }
}

export function storageLocal(par){//退出登录 或者登录 存储或删除 localStorage 
    const vm = this;
    if(par.mailbox){ //有传参数就是登录，否则就是退出
        localStorage['mailbox'] = par.mailbox; //邮箱
        localStorage['userName'] = par.userName; //用户名
        localStorage['type'] = par.type; //用户类型
        localStorage['customerId'] = par.customerId;   //用户id
        localStorage['createTime'] = par.createTime;  //创建时间
        if(par.userName){
            vm.userName = par.userName;
        }
    }else{
        localStorage.removeItem('mailbox')
        localStorage.removeItem('userName')
        localStorage.removeItem('type')
        localStorage.removeItem('customerId')
        localStorage.removeItem('createTime')
        vm.userName = '';
        vm.$store.setLoginAction(0)
    }
}